import axios from 'axios';
import { useEffect, useState } from 'react';
import { serialize } from '../../utils/serializers/homeSerializer';

export const useHomeRequest = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = async () => {
    setIsLoading(true);
    try {
      setError(null);
      const response = await axios.get('v4/home');
      const parsed = serialize(response.data);
      setData(parsed);
      setIsLoading(false);
      setError(null);
    } catch (error) {
      setIsLoading(false);
      setData([]);
      setError('Error: ' + JSON.stringify(error));
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return { query: data, refresh, isLoading, error };
};